import { createStore } from "./createStore";
import type { FileEntry, RecentFolderRecord, ProjectRecord } from "../types";

export interface FilesState {
  projects: ProjectRecord[];
  recentFolders: RecentFolderRecord[];
  rootPath: string | null;
  rootName: string | null;
  selectedProjectId: string | null;
  entries: FileEntry[];
  selectedPath: string | null;
  error: string | null;
}

export const filesStore = createStore<FilesState>({
  projects: [],
  recentFolders: [],
  rootPath: null,
  rootName: null,
  selectedProjectId: null,
  entries: [],
  selectedPath: null,
  error: null,
});
